import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { createEventInterestAsync, deleteEventInterestAsync, getEventInterestByIdAsync, getEventInterestsByEventIdAsync, updateEventInterestAsync } from './eventInterestsThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const eventInterestsSlice = createSlice({
    name: 'eventInterests',
    initialState,
    reducers: {
        resetEventInterestsApiState(state) {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            // Create
            .addCase(createEventInterestAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createEventInterestAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.eventInterest = action.payload;
            if (state.eventInterests && Array.isArray(state.eventInterests)) {
                state.eventInterests.push(action.payload);
            }
        })
            .addCase(createEventInterestAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Update
            .addCase(updateEventInterestAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateEventInterestAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.eventInterest = action.payload;
            if (state.eventInterests && Array.isArray(state.eventInterests)) {
                const idx = state.eventInterests.findIndex((x) => x.id === action.payload.id);
                if (idx >= 0)
                    state.eventInterests[idx] = action.payload;
            }
        })
            .addCase(updateEventInterestAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Delete
            .addCase(deleteEventInterestAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteEventInterestAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(deleteEventInterestAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Get By Id
            .addCase(getEventInterestByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getEventInterestByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.eventInterest = action.payload;
        })
            .addCase(getEventInterestByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Get By Event Id
            .addCase(getEventInterestsByEventIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getEventInterestsByEventIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.paginatedeventInterests = action.payload;
        })
            .addCase(getEventInterestsByEventIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { resetEventInterestsApiState } = eventInterestsSlice.actions;
export default eventInterestsSlice.reducer;
